{
  "version": 1,
  "asset_id": "903aa180-10a7-4577-8683-4fad378beeea",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/903aa180-10a7-4577-8683-4fad378beeea/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/903aa180-10a7-4577-8683-4fad378beeea/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.avif",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1200w.avif",
  "size": 30444,
  "content_type": "image/avif",
  "created_at": "2026-08-27T15:20:37Z"
}
